import React from "react"
import Image from "next/image"

import CatCategory from "../CatCategory"
import "../../aff/extensions/CatCategoryExtensions"

const CatCategoryMiniView: React.FunctionComponent<{
    category: CatCategory,
}> = ({ category }) => {
    return (
        <div className="flex items-center justify-items-center gap-x-[6px]">
            <Image width="20" height="20" src={category.defaultIconSrc("tertiary") || "/images/ic_info_fitness_class_black_2.svg"} alt="Meeting Duration" />
            <h6 className="text-footnote text-black-700">{category.title}</h6>
        </div>
    )
}

export default CatCategoryMiniView
